import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  {
    backButtonWrapper: {
      position: "relative",
      width: "40px",
      height: "40px",
      background: "transparent",
      border: "0 none",
      cursor: "pointer",
    },
    bar: {
      width: "10px",
      height: "2px",
      background: "black",
      position: "absolute",
      transform: "rotate(-45deg)",
      borderRadius: "2px",
      top: "15px",
      left: "14px",
    },
    barReverse: {
      composes: "$bar",
      transform: "rotate(45deg)",
      top: "21px",
    },
  },
  { name: "BackButton" },
);

export { useStyles };
